import { createContext, useContext } from "react"

export type OriginData = {
  host: string
  hostname: string
  origin: string
  port: string
  protocol: string
}

export const OriginContext = createContext<OriginData | null>(null)

export function useOrigin() {
  const originData = useContext(OriginContext)

  if (!originData) {
    throw new Error("useOrigin must be used within a OriginContext.Provider")
  }

  return originData
}
